import React, { act, useState } from 'react';
import { Form, Button, Col, Row, InputGroup } from 'react-bootstrap';
import axios from '../axiosConfig';
import { useGoogleLogin } from '@react-oauth/google';
import { toast } from 'react-hot-toast';

import linkedinLogo from "../assets/images/linkedin_logo.png";
import googleLogo from "../assets/images/google_logo.png";
import facebookLogo from "../assets/images/facebook_logo.png";
import appleLogo from "../assets/images/apple_logo.png";

import sign_in from '../assets/images/sign_in.png';
import forgot_password from '../assets/images/forgot_pswd.png';
import eye_closed from '../assets/images/eye_closed.png'
import eye_open from '../assets/images/eye_open.png'
import '../assets/styles/LoginForm.css';

/* Login form used in the Login page from My Account */

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false); // To show the password

  const handleSubmit = async (e) => {
    e.preventDefault(); 

    try {
      const response = await axios.get('/sanctum/csrf-cookie');

    } catch (error) {
      console.error('Query error:', error);
    }

    toast.promise(
      axios.post('/api/login', { email, password }),
      {
        loading: 'Connexion en cours...',
        success: 'Vous êtes connecté avec succès !',
        error: 'Erreur lors de la connexion.',
      }
    )
    .then((response) => {
      console.log('Connexion réussie:', response);
    })
    .catch((error) => {
      console.error('Erreur de connexion:', error);
    });
  };

  // DEBUG AUTH

  // useEffect(() => {
  //     axios.get('/api/auth/me')
  //         .then((response) => {
  //             console.log('User data:', response.data);
  //         })
  //         .catch(() => {
  //             console.log('User not authenticated');
  //         });
  // }, []);


  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    scope: 'openid profile email',
    onSuccess: async (codeResponse) => {
        
        const data =  new FormData()
        data.append('code', codeResponse.code)
        const tokens = await axios.post(
            '/api/auth/google/callback', data);
        toast.success('Vous êtes connecter avec succès');
        

        
    },
    onError: (errorResponse) => {console.log(errorResponse);
    toast.error('Erreur lors de la connexion');}
});


  // const linkedinLogin = () => {
    
  //   const linkedInAuthURL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=78xusgoxk3r57o&redirect_uri=http://127.0.0.1:8000/api/auth/linkedin/callback&scope=profile%20email`;
  //   window.open(linkedInAuthURL, '_blank');
  // };

  const linkedinLogin = () => {
    
      const linkedInAuthURL = 'http://iqosys.com/api/auth/linkedin/redirect';
      window.location.href = linkedInAuthURL;
    };

  const facebookLogin = () => {
    const linkedInAuthURL = 'http://iqosys.com/api/auth/facebook/redirect';
      window.location.href = linkedInAuthURL;

  }

  

  // const linkedinLogin = async () => {
    

  //   try {
  //     const response = await axios.get('/api/auth/linkedin/redirect');

  //   } catch (error) {
  //     console.error('Request error: ', error);
  //   }
  // };

  const buttons = [
    { logo : linkedinLogo, text: 'Sign in with LinkedIn', action: linkedinLogin },
    { logo : googleLogo, text: 'Sign in with Google', action: googleLogin },
    { logo : facebookLogo, text: 'Sign in with Facebook', action: facebookLogin},
    { logo : appleLogo, text: 'Sign in with Apple', action: () => {} }
  ];

  return (
    <>
      <h6 className='top_sentence' style={{paddingLeft:"5px"}}>Email and password</h6>
        <Form className="p-0 m-0" onSubmit={handleSubmit}>
          <Form.Group controlId="formEmail" style={{ marginBottom: "3px" }}>
            <InputGroup>
              <InputGroup.Text className='input-label'>
                Email
              </InputGroup.Text>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="formPassword">
            <InputGroup>
              <InputGroup.Text className='input-label'>
                Password
              </InputGroup.Text>
              <Form.Control
                type={passwordVisible ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ paddingRight: "40px" }}
              />
              <Button
                onClick={() => setPasswordVisible(!passwordVisible)}
                style={{
                  variant: "link",
                  position: "absolute",
                  top:"19px",
                  right: "5px",
                  transform: "translateY(-50%)",
                  padding:"1px",
                  width: "30px",
                  height : "30px",
                  backgroundColor:"#0000ff",
                  borderRadius: "5px",
                }}
              >
                <img
                src={passwordVisible ? eye_closed : eye_open}
                alt={passwordVisible ? "Hide Password" : "Show Password"}
                title={passwordVisible ? "hide" : "show"}
                style={{ width: "90%", height: "auto" }}
              />
              </Button>
            </InputGroup>
          </Form.Group>

          <div>
            <Row className="d-flex flex-column align-items-start">
              <Col className="mb-1">
                <Button
                  variant="link"
                  type="submit"
                  className="form-button d-flex align-items-end"
                  style={{ 
                    border: 'none', 
                    textDecoration: 'none', 
                    display: 'flex', 
                    alignItems: 'center',
                    paddingLeft: "0",
                  }}
                >
                  <div 
                    style={{
                      backgroundColor: '#5000FF',
                      borderRadius: '10%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '30px', 
                      height: '30px'
                    }}
                  >
                    <img style={{width : "60%"}} src={sign_in} alt="sign-in" />
                  </div>
                  <span className="button-text" style={{ marginLeft: '10px' }}>Sign in</span>
                </Button>
              </Col>
            </Row>
            <Row className="d-flex flex-column align-items-start">
              <Col className="mb-2 ms-0">
                <Button
                  variant="link"
                  className="form-button d-flex align-items-end"
                  style={{ 
                    border: 'none', 
                    textDecoration: 'none', 
                    display: 'flex', 
                    alignItems: 'center',
                    paddingLeft: "0",
                  }}
                >
                  <div 
                    style={{
                      backgroundColor: '#5000FF',
                      borderRadius: '10%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '30px', 
                      height: '30px'
                    }}
                  >
                    <img style={{width : "60%"}} src={forgot_password} className="button-img" alt="sign-in" />
                  </div>
                  <span className="button-text" style={{ marginLeft: '10px' }}>Forgot password</span>
                </Button>
              </Col>
            </Row>
          </div>
          
        </Form>

        <br/>
        
        <Row className="d-flex flex-column align-items-start">
          {buttons.map((btn, index) => (
            <Col key={index} className="mb-1">
              <Button
                variant="link"
                className="form-button d-flex align-items-end"
                style={{ 
                  border: 'none', 
                  textDecoration: 'none', 
                  display: 'flex', 
                  alignItems: 'center',
                  paddingLeft: "0", 
                }}
                onClick={btn.action}
              >
                <div 
                  style={{
                    backgroundColor: '#5000FF',
                    borderRadius: '10%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px', 
                    height: '30px'
                  }}
                >
                  <img style={{width : "60%"}} src={btn.logo} className="button-img" alt="icon" />
                </div>

                <span className="button-text" style={{ marginLeft: '10px' }}>
                  {btn.text}
                </span>
              </Button>               
            </Col>
          ))}
        </Row>

        {/* <div className="mt-3 text-center d-flex justify-content-center">
          <Button
            variant="light"
            className="google-button d-flex align-items-center justify-content-center border rounded me-2"
            onClick={() => googleLogin()}
            style={{
              backgroundColor: '#ffffff',
              borderColor: '#dcdcdc',
              color: '#757575',
              fontWeight: '500',
              padding: '0',
              fontSize: '100%',
              width: '28%',
              minWidth: '200px',
            }}
          >
            <img
              src={googleLogo}
              alt="Google logo"
              style={{ width: '20px', height: '20px', marginRight: '10px' }}
            />
            Sign in with Google
          </Button>
          <Button
            variant="light"
            className="linkedin-button d-flex align-items-center justify-content-center rounded"
            onClick={() => linkedinLogin()}
            style={{
              backgroundColor: 'transparent',
              border: '1px solid #dcdcdc',
              padding: '0',
            }}
          >
            <img
              src={linkedinLogo}
              alt="LinkedIn logo"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </Button>
        </div>         */}
    </>
  );
};

export default LoginForm;